module.exports = __webpack_public_path__ + "img/charcoal_dark.e7f53f80.webp";